import React, { useState } from "react";
import Footer from '../../components/footer/Footer';
import FooterMob from '../../components/footer/FooterMob';
import Navbar from '../../components/navbar/Navbar';
import logo from '../../images/white-logo.png';
import { Form } from 'react-bootstrap';
import fb from '../../images/facebk.png';
import goog from '../../images/Google.png';
import { Link, useNavigate } from 'react-router-dom';
import MobNav from '../../components/Mobnav/MobNav';
import { HiOutlineLocationMarker } from "react-icons/hi";
import Modal from "react-bootstrap/Modal";
// import "./login.css";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseUrl, baseLocal } from "../../context/BaseUrl";


const StdRegister = () => {

    // const [Email, setEmail] = useState('')
    // const [Password, setPassword] = useState('')
    // const handleSignup = async () => {

    //     if (Email && Password.length > 8) {
    //         // console.log(Email, Password);
    //         const response = await fetch('https://obelabs.onrender.com/signup', {
    //             method: "post",
    //             headers: {
    //                 Accept: "application/json",
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify({
    //                 email: Email,
    //                 password: Password,
    //                 role: 'user',
    //                 mobile: 1000,
    //                 name: "name"
    //             })
    //         })

    //         const result = await response.json();
    //         alert("Registration Succesful! now please login")
    //     }

    //     else {
    //         alert("enter correct email and strong password!")
    //     }

    // }
  const navigate = useNavigate();


    const [Email, setEmail] = useState("");
    const [Password, setPassword] = useState("");
    const [PhoneReg, setPhoneReg] = useState("");
    const [NameReg, setNameReg] = useState("");
    const [EmailReg, setEmailReg] = useState("");
    const [PasswordReg, setPasswordReg] = useState("");

    const handleSignup = async (role) => {
        try {
          // const id = toast.loading("Processing...");
          // if (EmailReg && PhoneReg && NameReg && PasswordReg.length > 8) {
          const response = await fetch(`${baseUrl}/signup`, {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              email: EmailReg,
              password: PasswordReg,
              role: role,
              mobile: PhoneReg,
              name: NameReg,
            }),
          });
    
          const result = await response.json();
    
          if (result.code == 500) {
            toast.error(result.msg);
    
            return;
          }
    
          toast.success("You're registered successfuly");
    
          if (role == "institute") {
            navigate("/institute-register")
            return;
          }
    
          localStorage.setItem("user", JSON.stringify(result));
    
          setTimeout(() => {
            navigate(`/profile/${result.user._id}`);
          }, 1500);
    
          // }
        } catch (error) {
          toast.error("Internal Server Error !!", {
            position: toast.POSITION.TOP_LEFT,
          });
        }
      };

    return (

        <>
        <ToastContainer />
            <div className="upsc-background home-background">
                <div className="logged">
                    <Navbar logoimg={logo} />
                </div>
            </div>
            <MobNav dnone="d-none" />

            <div className="container row mx-auto m-5 justify-content-center">
                <div className="login-form py-5 ms-0 col-md-6 shadow col-12 px-5">
                    {/* <MobForm title='Register as Student' btn='Register' account='Login' with='Or Register In with' /> */}
                    {/* <Form>
                    <h4>Register as Student</h4>
                    <Form.Group className="mb-4">
                        <Form.Control onChange={e=>setEmail(e.target.value)} value={Email} required id="number" placeholder=" Mobile Number Or Email ID" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Control onChange={e=>setPassword(e.target.value)} value={Password} required id="Password" placeholder="Password" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <small>Forgot Password</small>
                    </Form.Group>
                    <button type="button" onClick={handleSignup} className='signbtn'>Sign in</button>
                    <Form.Group className="mb-4">
                        <Link to='/student-login' className='acct'>Already you have an account ?</Link>
                    </Form.Group>
                    
                </Form> */}
                <Form>
                <Modal.Header >
                  <h4>Register as Student</h4>
                </Modal.Header>

                <Form.Group className="mb-4">
                  <Form.Control
                    id="name"
                    onChange={(e) => setNameReg(e.target.value)}
                    value={NameReg}
                    placeholder="Full Name *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="number"
                    onChange={(e) => setPhoneReg(e.target.value)}
                    value={PhoneReg}
                    placeholder="Mobile Number *"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Control
                    id="email"
                    onChange={(e) => setEmailReg(e.target.value)}
                    value={EmailReg}
                    placeholder="Email ID *"
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Control
                    id="Password"
                    onChange={(e) => setPasswordReg(e.target.value)}
                    value={PasswordReg}
                    placeholder="Password *"
                  />
                </Form.Group>
                <Form.Group className="d-flex justify-content-between align-items-center mb-1">
                  <small className="text-black">
                    {" "}
                    <HiOutlineLocationMarker className="me-2" /> Delhi
                  </small>
                  <small>
                    <Link to="#" className="acct">
                      Change{" "}
                    </Link>
                  </small>
                </Form.Group>
                <button
                  type="button"
                  onClick={() => handleSignup("user")}
                  className="signbtn"
                >
                  {" "}
                  Register{" "}
                </button>
                <Form.Group className="mb-4">
                  <a to="/student-login" className="acct">
                    Login{" "}
                  </a>
                </Form.Group>
                {/* <p className="with"> Or Register In with </p>
                <div className="social">
                  <img src={goog} alt="google" />
                  <img src={fb} alt="facebook" />
                </div> */}
              </Form>
                </div>
            </div>

            <Footer /><FooterMob />
        </>

    )
}

export default StdRegister